import React from "react";
import Form from "rc-field-form";
import SubTopicItem from "../SubTopicItem";
import { BaseQuestionType } from "service/exercise";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { ListField } from "rc-field-form/es/List";

interface SubListProps {
    subTopics: ListField[];
    subTypes: BaseQuestionType[];
    onRemove: (index: number | number[]) => void;
    onUpdate: () => void; // 为了强制更新分值, 不得不加了这个字段
}

function SubTopicList({
    subTopics,
    subTypes,
    onRemove,
    onUpdate
}: SubListProps) {
    function onDelete(index: number | number[]) {
        onRemove(index);
        onUpdate();
    }

    const SortItem = SortableElement(
        ({ field, idx }: { field: any; idx: number }) => (
            <Form.Field {...field}>
                <SubTopicItem
                    index={idx}
                    subTypes={subTypes}
                    onDelete={() => onDelete(field.name)}
                    onUpdate={onUpdate}
                />
            </Form.Field>
        )
    );

    return (
        <div>
            {subTopics.map((field, index) => (
                <SortItem
                    key={field.name}
                    idx={index}
                    index={index}
                    field={field}
                />
            ))}
        </div>
    );
}

export default SortableContainer(SubTopicList);
